import React from "react";
import { Alert, Badge, Button, Card, Table } from "react-bootstrap";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import { isGuestAllowed, isKidsAllowed, isPartnerAllowed } from "../../../../../helpers/CommonHelper";

const MemberRecentRegistrations = ({ items }) => {
  const registration = [...items].reverse();

  return (
    <div className="member-recent-registrations">
      <Card className="card-primary">
        <Card.Header>
          <Card.Title>
            Recent Activity Registration(s){" "}
            {items &&
              items.length > 0 &&
              "- Total " + items.length + " item(s)"}
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-0 m-0 overflow-auto">
          {!items || items.length <= 0 ? (
            <Alert variant="warning mb-0">No records found.</Alert>
          ) : (
            <>
            <div className="registrationTable ">
                <Table bordered size="sm" className="p-0 m-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Activity</th>
                      {/* <th>Participation Fee</th> */}

                      <th>Partner Participating</th>
                      {/* <th>Partner Fee</th> */}

                      <th>Guests Participating</th>
                      <th>Kids Participating</th>
                      {/* <th>Guests Count</th> */}
                      {/* <th>Per Guest Fee</th> */}
                      <th> Member Status </th>
                      <th> Partner Status</th>
                      <th>Guest Status</th>
                      <th>Kids Status</th>
                      {/* <th>Confirmed</th> */}
                      {/* 
                                            <th> Status</th> */}
                      <th>Registration Date/Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registration.map((item, index) => {
                      return (
                        <>
                          <tr
                            index={index}
                            className={
                              item.additionalRequests &&
                              item.additionalRequests.length <= 0 &&
                              "borderBottom"
                            }
                          >
                            <td
                              rowSpan={
                                item.additionalRequests &&
                                item.additionalRequests.length > 0 &&
                                item.additionalRequests.length + 1
                              }
                            >
                              {index + 1}
                            </td>
                            <td
                              rowSpan={
                                item.additionalRequests &&
                                item.additionalRequests.length > 0 &&
                                item.additionalRequests.length + 1
                              }
                              className=""
                            >
                              <Button
                                href={`/activities/${item.activityId}`}
                                variant="link"
                              >
                                {item.activityName ? item.activityName : "-"}
                              </Button>
                            </td>
                            {/* <td className="text-center">{item.participationFee}</td> */}

                            <td className="text-center">
                              {isPartnerAllowed(item.activity) ? (
                                <ModuleDisplayBoolean
                                  value={item.partnerParticipating}
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                            {/* <td className="text-center">{item.partnerParticipationFee}</td> */}

                            <td className="text-center">
                              {isGuestAllowed(item.activity) ? (
                                <>
                                  {item.guestParticipating === "1" &&
                                  item.NumberOfGuestParticipating > 0 ? (
                                    <Badge bg="success">
                                      Yes ({item.NumberOfGuestParticipating})
                                    </Badge>
                                  ) : (
                                    <Badge bg="warning" text="dark">
                                      No
                                    </Badge>
                                  )}
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center">
                              {isKidsAllowed(item.activity) ? (
                                <>
                                  {item.kidsParticipating === "1" &&
                                  item.NumberOfKidsParticipating > 0 ? (
                                    <Badge bg="success">
                                      Yes ({item.NumberOfKidsParticipating})
                                    </Badge>
                                  ) : (
                                    <Badge bg="warning" text="dark">
                                      No
                                    </Badge>
                                  )}
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                            {/* <td className="text-center">{item.guestParticipationFee}</td> */}

                            <td className="text-center">
                              <>
                                {item.memberStatus === "1" ? (
                                  <Badge bg="success">Confirmed</Badge>
                                ) : item.memberStatus === "0" ? (
                                  <Badge bg="warning" text="dark">
                                    {" "}
                                    Payment Pending
                                  </Badge>
                                ) : (
                                  "-"
                                )}
                              </>
                            </td>
                            <td className="text-center">
                              {isPartnerAllowed(item.activity) ? (
                                <>
                                  {item.partnerParticipating === "1" &&
                                  item.partnerStatus === "1" ? (
                                    <Badge bg="success">Confirmed</Badge>
                                  ) : item.partnerParticipating === "1" &&
                                    item.partnerStatus === "0" ? (
                                    <Badge bg="warning" text="dark">
                                      {" "}
                                      Payment Pending
                                    </Badge>
                                  ) : (
                                    "-"
                                  )}
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center">
                              {isGuestAllowed(item.activity) ? (
                                <>
                                  {item.guestParticipating === "1" &&
                                  item.guestStatus === "1" ? (
                                    <Badge bg="success">Confirmed</Badge>
                                  ) : item.guestParticipating === "1" &&
                                    item.guestStatus === "0" ? (
                                    <Badge bg="warning" text="dark">
                                      {" "}
                                      Payment Pending
                                    </Badge>
                                  ) : (
                                    "-"
                                  )}
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center">
                              {isKidsAllowed(item.activity) ? (
                                <>
                                  {item.kidsParticipating === "1" &&
                                  item.kidsStatus === "1" ? (
                                    <Badge bg="success">Confirmed</Badge>
                                  ) : item.kidsParticipating === "1" &&
                                    item.kidsStatus === "0" ? (
                                    <Badge bg="warning" text="dark">
                                      {" "}
                                      Payment Pending
                                    </Badge>
                                  ) : (
                                    "-"
                                  )}
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                            {/* <td className="text-center">
                              <>
                                {item.requiredConfirmation === true ? (
                                  <>
                                    {item.reconfirmed === "1" ? (
                                      <div class="d-flex align-items-center justify-content-center">
                                        <span class="roundCircle green "></span>
                                        <span class="ms-1 roundCircleText green">
                                          Confirmed
                                        </span>
                                      </div>
                                    ) : (
                                      <div class="d-flex align-items-center justify-content-center">
                                        <span class="roundCircle "></span>
                                        <span class="ms-1 roundCircleText">
                                          Pending
                                        </span>
                                      </div>
                                    )}{" "}
                                  </>
                                ) : (
                                  "-"
                                )}
                              </>
                            </td> */}
                            <td class="font-small fs-12 text-secondary fontItalic ">
                              <ModuleDisplayDateTime value={item.createdAt} />
                            </td>
                          </tr>
                          {item.additionalRequests &&
                            item.additionalRequests.length > 0 &&
                            item.additionalRequests.map((request, index) => {
                              return (
                                <tr
                                  className={
                                    index + 1 === item.additionalRequests.length
                                      ? "borderBottom bg-table"
                                      : "bg-table"
                                  }
                                >
                                  <td className="text-center">
                                    {isPartnerAllowed(item.activity) ? (
                                      <>
                                        {request.partnerParticipating ===
                                        "1" ? (
                                          <Badge bg="success">Yes</Badge>
                                        ) : (
                                          <Badge bg="warning" text="dark">
                                            No
                                          </Badge>
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="text-center">
                                    {isGuestAllowed(item.activity) ? (
                                      <>
                                        {request.guestParticipating === "1" ? (
                                          <Badge bg="success">
                                            Yes (
                                            {request.NumberOfGuestParticipating}
                                            )
                                          </Badge>
                                        ) : (
                                          <Badge bg="warning" text="dark">
                                            No
                                          </Badge>
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="text-center">
                                    {isKidsAllowed(item.activity) ? (
                                      <>
                                        {request.kidsParticipating === "1" ? (
                                          <Badge bg="success">
                                            Yes (
                                            {request.NumberOfKidsParticipating})
                                          </Badge>
                                        ) : (
                                          <Badge bg="warning" text="dark">
                                            No
                                          </Badge>
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="text-center">
                                    <>
                                      {request.memberStatus === "1" ? (
                                        <Badge bg="success">Confirmed</Badge>
                                      ) : request.memberStatus === "0" ? (
                                        <Badge bg="warning" text="dark">
                                          Payment Pending
                                        </Badge>
                                      ) : (
                                        "-"
                                      )}
                                    </>
                                  </td>

                                  <td className="text-center">
                                    {isPartnerAllowed(item.activity) ? (
                                      <>
                                        {request.partnerStatus === "1" ? (
                                          <Badge bg="success">Confirmed</Badge>
                                        ) : request.partnerParticipating ===
                                          "1" ? (
                                          <Badge bg="warning" text="dark">
                                            Payment Pending
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="text-center">
                                    {isGuestAllowed(item.activity) ? (
                                      <>
                                        {request.guestStatus === "1" ? (
                                          <Badge bg="success">Confirmed</Badge>
                                        ) : request.guestParticipating ===
                                          "1" ? (
                                          <Badge bg="warning" text="dark">
                                            Payment Pending
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="text-center">
                                    {isKidsAllowed(item.activity) ? (
                                      <>
                                        {request.kidsStatus === "1" ? (
                                          <Badge bg="success">Confirmed</Badge>
                                        ) : request.kidsParticipating ===
                                          "1" ? (
                                          <Badge bg="warning" text="dark">
                                            Payment Pending
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  {/* <td className="text-center">-</td> */}
                                  <td class="font-small fs-12 text-secondary fontItalic ">
                                    <ModuleDisplayDateTime
                                      value={request.createdAt}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                        </>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default MemberRecentRegistrations;
